import { Controller } from "stimulus"
import _find from 'lodash/find'

# Starting the eventual transition from Backbone -> Stimulus for event forms.
export default class extends Controller
  @values =
    eventType: Object
    mappableLocation: String

  @targets: [
    'eventSponsorFieldset'
    'locationContainerFieldset'
    'locationImpliedVirtualFieldset'
    'locationFieldset'
    'virtualMappableLocationField'
    'impliedVirtualMessage'
  ]

  eventTypeValueChanged: (newValue, oldValue) ->
    @update()

  eventTypeEmpty: ->
    Object.keys(@eventTypeValue).length == 0

  handleEventTypeChange: (event) ->
    eventTypeDataFromSelection = event.target.selectedOptions[0].dataset.model
    # If the chosen option is the "Blank" option, it won't have a data-model attribute, so we just set the
    # value to an empty object here.
    @eventTypeValue = (eventTypeDataFromSelection && JSON.parse(eventTypeDataFromSelection)) || {}

  handleMappableLocationChange: (event) ->
    @mappableLocationValue = event.target.value

  mappableLocationValueChanged: (newValue, oldValue) ->
    @update()

  update: ->
    @updateEventSponsorFieldset()
    @updateLocationFieldset()

  updateEventSponsorFieldset: ->
    if @hasEventSponsorFieldsetTarget
      if @eventTypeValue.disables_sponsorship_fields || @eventTypeEmpty()
        @eventSponsorFieldsetTarget.hidden = true
        @eventSponsorFieldsetTarget.disabled = true
      else
        @eventSponsorFieldsetTarget.hidden = false
        @eventSponsorFieldsetTarget.disabled = false

  updateLocationFieldset: ->
    # # If no event type has been chosen, hide and disable the entire location container fieldset.
    # if @eventTypeEmpty()
    #   @locationContainerFieldsetTarget.disabled = true
    #   @locationContainerFieldsetTarget.hidden = true
    # else
    #   @locationContainerFieldsetTarget.disabled = false
    #   @locationContainerFieldsetTarget.hidden = false

    if @eventTypeValue.implies_virtual
      # Tick the "Online" location box.
      @virtualMappableLocationFieldTarget.checked = true
      @virtualMappableLocationFieldTarget.dispatchEvent(new Event('input', { bubbles: true }))

      # Show the implied virtual message
      @impliedVirtualMessageTarget.hidden = false
      
      # Hide and disable the location fieldset.
      @locationFieldsetTarget.disabled = true
      # @locationFieldsetTarget.hidden = true

      # Show and enable the implied virtual fieldset.
      @locationImpliedVirtualFieldsetTarget.disabled = false
      @locationImpliedVirtualFieldsetTarget.hidden = false
    else
      # Hide and disable the location fieldset.
      @locationFieldsetTarget.disabled = false
      # @locationFieldsetTarget.hidden = false
      
      # Hide the implied virtual message
      @impliedVirtualMessageTarget.hidden = true

      # Show and enable the implied virtual fieldset.
      @locationImpliedVirtualFieldsetTarget.disabled = true
      @locationImpliedVirtualFieldsetTarget.hidden = true